export const sendOtpV2 = async (
  phoneCode: string,
  mobile: string,
  reCaptchaResponse: string,
) => {
  const url = '/bo/api/sendOtpV2';

  const payload = {
    phoneCode,
    mobile,
    reCaptchaResponse,
    whatsappOptin: true,
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    return {
      success: false,
      Code: '500',
      Message: 'Something went wrong. Please try again.',
    };
  }
};

export const signUp = async (
  Mobile: string,
  Otp: string,
  PhoneCode: string = '91',
  Name?: string,
  EmailId?: string,
  serviceType: string = 'BUS',
) => {
  const url = '/bo/api/signUp';

  const payload: any = {
    Mobile,
    Otp,
    PhoneCode,
    serviceType,
  };

  if (Name) {
    payload.Name = Name;
  }
  if (EmailId) {
    payload.EmailId = EmailId;
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    
    if (!response.ok || !result.success) {
      return {
        success: false,
        error: 'Invalid OTP. Please try again.',
      };
    }

    return result;
  } catch (error) {
    return {
      success: false,
      error: 'Something went wrong. Please try again.',
    };
  }
};

export const resendOtp = async (
  phoneCode: string,
  mobile: string,
  reCaptchaResponse: string,
) => {
  return sendOtpV2(phoneCode, mobile, reCaptchaResponse);
};

export const logoutUser = async () => {
  const url = '/bo/api/logoutUser';

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      return { success: false };
    }

    return { success: true };
  } catch (error) {
    return { success: false };
  }
};
